'use strict';
import reqwest from 'reqwest';
import store from 'store';

var accessToken = null;

export default {
    cachedImagePath(imageUrl, width=650) {
        return imageUrl; //'https://images.msnode.de/display?url=' + imageUrl + '&w=' + width + '&h=0&op=resize&upscale=0';
    },
    removeToken() {
        accessToken = null;
    },
    registerToken(token) {
        accessToken = token;
    },
    getHtml(url) {
        return reqwest({
            url: url,
            method: 'get'
        });
    },
    getLocale(local) {
        // loca the local from local
        return reqwest({
            url: window.config.baseUrl + '/language/' + local,
            type: 'json',
            method: 'get',
            headers: {
                'Authorization': accessToken
            }
        });
    },
    get(url, params) {
        return reqwest({
            url: window.config.baseUrl + '/' + url,
            data: params,
            type: 'json',
            method: 'get',
            headers: {
                'Authorization': accessToken
            }
        });
    },
    post(url, params) {
        // console.log('reqwest POST, payload is', params);
        return reqwest({
            url: window.config.baseUrl + '/' + url,
            data: JSON.stringify(params),
            type: 'json',
            method: 'post',
            contentType: 'application/json',
            headers: {
                'Authorization': accessToken,
                'X-CSRF-Token': store.get('_CSRF')
            }
        });
    }
};



// WEBPACK FOOTER //
// ./app/utils/api.js